module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar-l side-scroll header-navbar-fixed",
    attrs: {
      "id": "page-container"
    }
  }, [_c('main', {
    staticStyle: {
      "padding-top": "0px"
    },
    attrs: {
      "id": "main-container"
    }
  }, [_c('div', {
    staticClass: "content content-boxed"
  }, [_vm._t("default")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e5ad934e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/published.vue
// module id = 831
// module chunks = 3